import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const DriftHuntersGame = () => {
  const gameUrl = 'https://script.google.com/macros/s/AKfycbw8iHPqdVFEzquUYbNxFVAu1Tw4Nri5SWMRLdP_c7a84vCOHVG7YUWuhjSVptg1SVHr/exec';

  // Proper SEO for the Drift Hunters Unblocked page (dynamic title + meta for SPA)
  // Optimized for "drift hunters unblocked" searches to improve Google ranking chances
  useEffect(() => {
    const originalTitle = document.title;
    document.title = 'Drift Hunters Unblocked - Play Free Online Drifting Game | MathConvert';

    const metaDesc = document.querySelector('meta[name="description"]');
    const originalDesc = metaDesc ? metaDesc.getAttribute('content') : '';
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Play Drift Hunters Unblocked for free! The full unblocked version with realistic 3D drifting, 25+ customizable cars, and car tuning. Works on school Chromebooks, restricted networks, and anywhere the original is blocked. Full keyboard controls and in-browser embed.'
      );
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    const originalKeywords = metaKeywords ? metaKeywords.getAttribute('content') : '';
    if (metaKeywords) {
      metaKeywords.setAttribute(
        'content',
        'drift hunters unblocked, play drift hunters unblocked, unblocked drifting game, drift hunters, online drifting simulator, car drifting unblocked, free drift game unblocked, drifting game for school'
      );
    }

    // Open Graph tags for better social sharing / SEO
    const setOrCreateMeta = (property, content) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setOrCreateMeta('og:title', 'Drift Hunters Unblocked - Free Online Drifting Game');
    setOrCreateMeta(
      'og:description',
      'Play the full Drift Hunters Unblocked version online. Realistic drifting physics, car customization, and high-score chasing. Works unblocked on school and work networks.'
    );
    setOrCreateMeta(
      'og:image',
      'https://img.itch.zone/aW1hZ2UvMTY5NjQ2My85OTM3Njc2LnBuZw==/original/4o0z0j.png'
    );
    setOrCreateMeta('og:url', window.location.href);
    setOrCreateMeta('og:type', 'game');

    return () => {
      document.title = originalTitle;
      if (metaDesc) metaDesc.setAttribute('content', originalDesc);
      if (metaKeywords) metaKeywords.setAttribute('content', originalKeywords);
    };
  }, []);

  const toggleFullscreen = () => {
    const el = document.querySelector('.game-embed-wrapper');
    if (!el) return;

    if (document.fullscreenElement) {
      document.exitFullscreen?.().catch(() => {});
    } else if (el.requestFullscreen) {
      el.requestFullscreen().catch(() => {});
    } else if (el.webkitRequestFullscreen) {
      el.webkitRequestFullscreen();
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen();
    }
  };

  return (
    <div className="game-page">
      <div className="game-topbar">
        <Link to="/" className="back-btn">← Back to MathConvert</Link>
        
        <div className="game-title-area">
          <h1>Drift Hunters Unblocked</h1>
          <span className="game-badge">Unblocked Drifting Game • Play in School & Work</span>
        </div>

        <button 
          onClick={toggleFullscreen} 
          className="btn btn-secondary fullscreen-btn"
        >
          <i className="fas fa-expand"></i> Fullscreen
        </button>
      </div>

      {/* SEO-optimized intro paragraph using "unblocked" naturally */}
      <div className="game-intro">
        <p>
          Play <strong>Drift Hunters Unblocked</strong> — the full version of the popular 3D drifting game that works on school Chromebooks, 
          office networks, and any restricted environment. No downloads, no registration, just pure drifting action right in your browser.
        </p>
      </div>

      <div className="game-embed-wrapper">
        <iframe 
          src={gameUrl}
          title="Drift Hunters Unblocked"
          allow="fullscreen; autoplay"
          allowFullScreen
        />
      </div>

      <div className="how-to-play-container">
        <h2>How to Play Drift Hunters Unblocked</h2>
        
        <div className="controls-grid">
          <div className="control-row">
            <span className="key">W / ↑</span>
            <span>Accelerate / Gas</span>
          </div>
          <div className="control-row">
            <span className="key">S / ↓</span>
            <span>Brake / Reverse</span>
          </div>
          <div className="control-row">
            <span className="key">A / ←</span>
            <span>Steer Left</span>
          </div>
          <div className="control-row">
            <span className="key">D / →</span>
            <span>Steer Right</span>
          </div>
          <div className="control-row">
            <span className="key">Space</span>
            <span>Handbrake (Initiate Drift)</span>
          </div>
          <div className="control-row">
            <span className="key">Left Shift</span>
            <span>Shift Up Gears</span>
          </div>
          <div className="control-row">
            <span className="key">Left Ctrl</span>
            <span>Shift Down Gears</span>
          </div>
          <div className="control-row">
            <span className="key">C</span>
            <span>Change Camera View</span>
          </div>
        </div>

        <div className="play-tips">
          <strong>Pro Tip:</strong> Use the handbrake (Space) to start your drift, then counter-steer and modulate the throttle. 
          Smooth, precise inputs will give you the longest and highest-scoring drifts! This unblocked version includes all the same great physics and tuning as the original.
        </div>
      </div>
    </div>
  );
};

export default DriftHuntersGame;
